import type { AutomationStatsDto } from "../shared/dto";

export function hasAutomationTimingEstimate(
  stats: AutomationStatsDto | null | undefined
): stats is AutomationStatsDto & { medianMs: number } {
  return Boolean(stats && stats.sampleSize >= 2 && stats.medianMs !== null);
}

export function AutomationTimingEstimate(props: {
  stats?: AutomationStatsDto | null;
  t: (key: string) => string;
  className?: string;
}) {
  if (!hasAutomationTimingEstimate(props.stats)) return null;
  const minutes = Math.max(1, Math.round(props.stats.medianMs / 60_000));
  const copy = props.t("automationTiming.typical")
    .replace("{minutes}", String(minutes))
    .replace("{count}", String(props.stats.sampleSize));
  return (
    <small
      className={`automation-timing-estimate${props.className ? ` ${props.className}` : ""}`}
      data-automation-timing-estimate
    >
      {copy}
    </small>
  );
}
